import { render } from "./EnlargeImage.vue?vue&type=template&id=2dfe1a5c"
import script from "./EnlargeImage.vue?vue&type=script&lang=js"
export * from "./EnlargeImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__